import { useState } from "react";

interface InfoBannerProps {
  storageKey: string;
  children: React.ReactNode;
}

/**
 * A dismissable info banner. Once dismissed, stays hidden via localStorage.
 */
export function InfoBanner({ storageKey, children }: InfoBannerProps) {
  const fullKey = `info-dismissed:${storageKey}`;
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(fullKey) === "1",
  );

  if (dismissed) return null;

  return (
    <div className="mb-3 flex items-start gap-2 rounded-radius-sm bg-accent-muted/50 px-3 py-2 text-[11px] leading-relaxed text-text-secondary">
      <span className="mt-px shrink-0 text-accent">i</span>
      <div className="flex-1">{children}</div>
      <button
        type="button"
        onClick={() => {
          localStorage.setItem(fullKey, "1");
          setDismissed(true);
        }}
        className="shrink-0 text-[10px] text-text-muted hover:text-text-primary"
        title="Dismiss"
      >
        ✕
      </button>
    </div>
  );
}
